import { defineMessages } from '@atlassian/jira-intl';

// eslint-disable-next-line formatjs/no-multiple-plurals
export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.title-non-final',
		defaultMessage: 'What you’ll need to set up',
		description: 'Title of step two for optimal tooling wizard',
	},
	descriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.description-non-final',
		defaultMessage:
			'Almost all of your Opsgenie settings will be synced with Jira, only some configurations will need your involvement.',
		description: 'Description of step two for optimal tooling wizard',
	},
	usersRoleTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.users-role-title-non-final',
		defaultMessage: "Verify users' roles",
		description: 'Title of alerts section for optimal tooling wizard',
	},
	usersRoleDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.users-role-description-non-final',
		defaultMessage: `{adminCount, plural,
            =0 {{userCount, plural, =0 {} one {{userCount} Opsgenie user} other {{userCount} Opsgenie users}}}
             one {{userCount, plural, =0 {{adminCount} Opsgenie admin} one {{adminCount} Opsgenie admin and {userCount} user} other {{adminCount} Opsgenie admin and {userCount} users}}}
            other {{userCount, plural, =0 {{adminCount} Opsgenie admins} one {{adminCount} Opsgenie admins and {userCount} user} other {{adminCount} Opsgenie admins and {userCount} users}}}
        } who don’t have the same role in Jira Service Management.`,
		description: 'Description of users role section for optimal tooling wizard',
	},
	chatIntegrationsTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-title-non-final',
		defaultMessage: 'Copy chat integrations',
		description: 'Title of chat integrations section for optimal tooling wizard',
	},
	chatIntegrationsDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.chat-integrations-description-non-final',
		defaultMessage:
			'Connect your chat tools and copy your {chatCount, plural, one {# Opsgenie chat integration} other {# Opsgenie chat integrations}} to Jira Service Management.',
		description: 'Description of chat integrations section for optimal tooling wizard',
	},
	configurationsTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.configurations-title-non-final',
		defaultMessage: 'And a few more configurations:',
		description: 'Title of configurations section for optimal tooling wizard',
	},
	actionsAndIncidentRulesNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.actions-and-incident-rules-non-final',
		defaultMessage: 'Actions and incident rules',
		description: 'Actions and incident rules configuration title for optimal tooling wizard',
	},
	heartbeatsNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.heartbeats-non-final',
		defaultMessage: 'Heartbeats',
		description: 'Heartbeats configuration title for optimal tooling wizard',
	},
	readMoreAboutNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.two.read-more-about-non-final',
		defaultMessage: 'Read more about setting up operations',
		description: 'Link to learn more about setting up operations in the optimal tooling wizard',
	},
});
